import React, {useCallback, useEffect, useState} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useSelector } from 'react-redux';
import { placeTypes } from '../../data/PlaceTypes';
import { FancySelect } from './inputs';
import './inputs/inputs.scss';
import './popup.scss';


export function PlaceSearch(props) {
  const [inputValue, setInputValue] = useState('');
  const [locationType, setLocationType] = useState(props.locationType ? props.locationType : placeTypes[1])
  const [options, setOptions] = useState([]);
  const autocompleteService = useSelector(state => state.autocompleteService);
  const placesService = useSelector(state => state.placesService);
  const value = props.value;
  const setValue = props.setValue;
  const filled = Boolean(value || inputValue);

  const populateAutocomplete = useCallback(() => {
    if(autocompleteService && inputValue){
      const autocompleteOptions = {input:inputValue, types:locationType.value};
      autocompleteService.getPlacePredictions(autocompleteOptions, (results, status) => {
        if(status === 'OK'){
          setOptions(results)
        }else{
          setOptions([])
          console.log('Autcomplete returned not ok response')
        }
      })
      .catch(error=>console.log(error));
    }
  }, [autocompleteService, inputValue, locationType.value])

  useEffect(() => {
    const delayDebounceFn = setTimeout(populateAutocomplete, 0);
    return () => clearTimeout(delayDebounceFn)
  }, [populateAutocomplete])

  const setLocationDetails = async (newLocation) => {
    if(!newLocation)
        setValue(null);
    else if(placesService){
        placesService.getDetails({placeId: newLocation.place_id}, (result, status) => {
            setValue({
                description: newLocation.description,
                placeId: newLocation.place_id,
                locationType,
                coordinates: {
                    lat: result.geometry.location.lat(),
                    lng: result.geometry.location.lng()
                }
            })
        })
    }
  }

  return (
    <>
        <FancySelect
            style={{width:'180px', minWidth:'180px', flexShrink:0, marginRight:'10px'}}
            label="Location Type"
            value={locationType.id}
            onChange={(value) => {
                setLocationType(placeTypes[value]);
            }}
            options={Object.values(placeTypes).map((type) => ({
                value: type.id,
                label: type.name,
            }))}
        />
        <Autocomplete
            fullWidth
            className="place-search-autocomplete"
            slotProps={{
                popper: { className: 'fancy-autocomplete-popper place-search-popper' },
            }}
            getOptionLabel={(option) =>
                typeof option === 'string' ? option : option.description
            }
            filterOptions={(x) => x}
            options={options}
            autoComplete
            filterSelectedOptions
            value={value}
            noOptionsText="No locations"
            onChange={(event, newValue) => {
                setOptions(newValue ? [newValue, ...options] : options);
                setLocationDetails(newValue);
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <div className={[
                    'fancy-tf',
                    'fancy-tf--full',
                    props.error ? 'fancy-tf--error' : '',
                    filled ? 'fancy-tf--floating' : '',
                    'fancy-tf--has-label',
                    'place-search-field',
                ].filter(Boolean).join(' ')}>
                    <div className="fancy-tf__field" ref={params.InputProps.ref}>
                        <span className="fancy-tf__adornment fancy-tf__adornment--start">
                            <LocationOnIcon/>
                        </span>
                        <div className="fancy-tf__inner">
                            <label htmlFor={params.id} className="fancy-tf__label">Location</label>
                            <input
                                {...params.inputProps}
                                id={params.id}
                                className="fancy-tf__input"
                            />
                        </div>
                        {params.InputProps.endAdornment}
                    </div>
                </div>
            )}
            renderOption={(props, option) => {
                const main = option.structured_formatting?.main_text || option.description;
                const secondary = option.structured_formatting?.secondary_text;

                return (
                <li {...props} className={[props.className, 'popup-option', 'place-search-option'].filter(Boolean).join(' ')}>
                    <span className="popup-option__icon">
                        <LocationOnIcon style={{ color: '#525252' }} />
                    </span>
                    <span className="popup-option__body">
                        <span className="popup-option__title">{main}</span>
                        {secondary && <span className="popup-option__subtitle">{secondary}</span>}
                    </span>
                    <ChevronRightIcon className="popup-option__chevron" />
                </li>
                );
            }}
        />
    </>
  );
}
